/**
 * CONNOX GMBH CONFIDENTIAL
 * ________________________
 *
 * Copyright (c) 2005 - 2018 Connox GmbH, All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Connox GmbH and its suppliers, if any. The intellectual and
 * technical concepts contained herein are proprietary to Connox GmbH and
 * its suppliers and may be covered by German Laws and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * Connox GmbH.
 */
import {IAddressData} from "@connox/typescript-library";
import {IAddressForm} from "./AddressFormData";

export default class AddressFormDataReduced {
  public get firstName(): string {
    return this.form.FirstName.value;
  }

  public get lastName(): string {
    return this.form.LastName.value;
  }

  public get email(): string {
    return this.form.Email.value;
  }

  public get gender(): "M" | "F" {
    return this.form.Gender.value as "M" | "F";
  }

  public form: IAddressForm;

  constructor(form: IAddressForm) {
    this.form = form;
  }

  public toJSONReduced(): Pick<IAddressData, "email" | "firstName" | "gender" | "lastName"> {
    return {
      email: this.email,
      firstName: this.firstName,
      gender: this.gender,
      lastName: this.lastName,
    };
  }
}
